<div class="bg-gradient-primary-01">
  <div class="container">

    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-6 d-none d-lg-block bg-login-image">
                <img src="./assets/img/logo.png" class="img-fluid">
              </div>
              <div class="col-lg-6">
                <div class="p-5 login-cent">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-5">Login</h1>
                  </div>
                  <div *ngIf="errMsg" class="alert alert-danger m-1" style="padding-left:4%; margin-bottom:0rem">
                    {{errMsg}}
                  </div>
                  <form class="user" [formGroup]="loginForm" (ngSubmit)="onFormSubmit()">
                    <div class="form-group">
                      <input type="text" class="form-control form-control-user" id="exampleInputEmail"
                        aria-describedby="emailHelp" placeholder="Email..." formControlName="email"
                        autocomplete="off" [ngClass]="{ 'is-invalid': submitted && fval.email.errors }">
                        <div class="text-danger" *ngIf="submitted && fval.email.errors">
                          <div *ngIf="fval.email.errors.required">Email can't be blank</div>
                          <div *ngIf="fval.email.errors.email">Enter a valid email address</div>
                        </div>
                    </div>
                    <div class="form-group">
                      <input type="password" class="form-control form-control-user" id="exampleInputPassword"
                        placeholder="Password" formControlName="password" autocomplete="off" [ngClass]="{ 'is-invalid': submitted && fval.password.errors}">
                        <div class="text-danger" *ngIf="submitted && fval.password.errors">
                          <div *ngIf="fval.password.errors.required">
                          Password can't be blank
                          </div>
                          <div *ngIf="fval.password.errors.minlength">Password must be at least 6 characters</div>
                          </div>
                    </div>

                    <button type="submit" class="btn btn-primary btn-user btn-block">
                      Login
                    </button>

                  </form>
                  <hr>
                  <div class="text-center">
                    <a class="small" [routerLink]="['/reset-password']">Forgot Password?</a>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</div>
